import { ArrayDataSource } from './BaseDataSources';
import { IPackageSubType } from '../Interfaces';

export class PackageSubTypeSource extends ArrayDataSource<IPackageSubType> {
  public constructor (packageTypeId: number) {
    super('/datasource/packagesubtypes', { packageTypeId });
  }
}